// NOTE: 原則 ~/api 以外では使用しない(fetch関数を定義してから使う)
import queryString from "query-string"

import { SuccessInfraResponse } from "~/api/_common/InfraResponse"

type Arg = {
  endpoint: string
  method: "GET" | "POST" | "PUT" | "DELETE"
  body?: object
  query?: object
  option?: {
    baseApiUrl?: string
  }
}

export const GET = (endpoint: string, query?: object, option?: Arg["option"]) => {
  return makeHttpRequest({ endpoint, method: "GET", query, option })
}

export const POST = (endpoint: string, body?: object, option?: Arg["option"]) => {
  return makeHttpRequest({ endpoint, method: "POST", body, option })
}

export const PUT = (endpoint: string, body?: object, option?: Arg["option"]) => {
  return makeHttpRequest({ endpoint, method: "PUT", body, option })
}

export const DELETE = (endpoint: string, body?: object) => {
  return makeHttpRequest({ endpoint, method: "DELETE", body })
}

const makeHttpRequest = async ({ endpoint, method, body, query, option }: Arg): Promise<any> => {
  const params: RequestInit = {
    method: method,
    mode: "cors", // クロスオリジンリクエストをするのでCORSモードにする
    credentials: "include", // クレデンシャルを含める指定
    headers: { Accept: "application/json" },
  }
  if (method !== "GET") {
    params.headers = { ...params.headers, "Content-Type": "application/json" }
    params.body = JSON.stringify(body)
  }

  let queryParams = ""
  if (method === "GET" && query) {
    queryParams = `?${queryString.stringify(query, { arrayFormat: "bracket" })}`
  }

  const baseApiUrl: string = option?.baseApiUrl ? option.baseApiUrl : `${process.env.INFRA_API_URL}${endpoint}`
  const apiUrl = `${baseApiUrl}${queryParams}`

  if (option?.baseApiUrl) {
    console.log("baseApiUrl", option?.baseApiUrl)
  }

  if (process.env.STORYBOOK) {
    console.log(`${method}: ${apiUrl}\nbody: ${JSON.stringify(body, null, 2)}`)
    const mockResult: SuccessInfraResponse<unknown> = {
      result: "SUCCESS",
      data: {},
    }
    return mockResult
  }

  const res = await fetch(apiUrl, params).catch((e) => {
    // ネットワークエラーの場合にのみここを通る
    // 400系、500系エラーの場合はここを通らず、res.ok === false になる
    return { error: e.message }
  })

  if ("error" in res) {
    return res
  }

  // 未ログイン時に/meへのアクセスが走る度にConsoleにエラーが残るのでclearする
  if (process.env.ENV === "production" && res.status === 401) {
    console.clear()
  }

  return res.json().catch((e) => {
    // NOTE: 本当はcatchのブロックを消したいが、apiの互換性のため残している
    // TODO: 各apiの動作が確認できたら catchのブロックを消す
    console.error(e)
    return {}
  })
}
